import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { combineLatest } from 'rxjs';
import { publicEventApi } from 'src/app/services/constants/api.constants';
import { LIMIT } from 'src/app/services/constants/general.constants';
import { HelpersService, HttpBaseService } from '@evento-ng/libs';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-new-choose-ticket',
  templateUrl: './new-choose-ticket.component.html',
  styleUrls: ['./new-choose-ticket.component.scss'],
})
export class NewChooseTicketComponent {
  @ViewChild('eventDaysEl', { static: false }) eventDaysEl!: ElementRef;
  @Input() eventId: any;
  @Input() showTickets = false;
  @Input() showCartMobile = false;

  @Output() tickets = new EventEmitter<[]>();
  schedules: any[] = Array(LIMIT);
  unscheduled: any[] = [];
  eventDays: any[] = Array(LIMIT);
  selectedDayIndex!: number;
  currentIndex = 0;
  isMobile = false;
  constructor(
    public ticketService: TicketService,
    public helpers: HelpersService,
    public translate: TranslateService,
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.getTickets();
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  getTickets() {
    this.spinner.show();
    const schedules = this.dataService.get(
      `${publicEventApi}/${this.eventId}/schedules`,
      { headers: { 'Accept-Language': this.translate.currentLang } }
    );
    const unscheduled = this.dataService.get(
      `${publicEventApi}/${this.eventId}/unscheduled`,
      { headers: { 'Accept-Language': this.translate.currentLang } }
    );
    combineLatest([schedules, unscheduled]).subscribe(
      ([schedules, unscheduled]) => {
        this.eventDays = schedules;
        this.unscheduled = unscheduled?.map((ticket: any) => {
          return {
            ticket,
            timeSchedules: [],
          };
        });
        this.selectFirstAvailableDay();
      }
    );
  }

  selectFirstAvailableDay() {
    this.spinner.show();
    setTimeout(() => {
      let index = -1;
      this.eventDays.map((item, i) => {
        var elementExists = document.getElementById('day-' + i);
        if (elementExists) {
          if (index == -1) {
            index = i;
          } else {
          }
          return;
        }
      });
      this.selectDay(index, this.eventDays[index]);
      this.spinner.hide();
    }, 2000);
  }

  scrollView(direction: string): void {
    const elementWidth = this.eventDaysEl.nativeElement.clientWidth;
    let scrollValue;

    switch (direction) {
      case 'next':
        scrollValue = this.eventDaysEl.nativeElement.scrollLeft + elementWidth;
        break;
      case 'prev':
        scrollValue = this.eventDaysEl.nativeElement.scrollLeft - elementWidth;
        break;
      default:
    }

    this.eventDaysEl.nativeElement.scrollTo({
      left: scrollValue,
      behavior: 'smooth',
    });
  }

  goNext(): void {
    this.scrollView('next');
  }
  goPrev(): void {
    this.scrollView('prev');
  }

  hidePreviousDays(day: any): boolean {
    return new Date().getTime() < day?.endAt * 1000;
  }

  selectDay(index: number, day: any): void {
    this.selectedDayIndex = index + 1;
    this.schedules = [...day?.ticketSchedules, ...this.unscheduled];
    this.spinner.hide();
  }
}
